import { useReducedMotion } from "framer-motion";
import { Reveal, SectionTag, ArrowLink, MaskedLines } from "@/components/Reveal";
import { FlowH, FlowV } from "@/components/InsightVisuals";

const FRAMEWORK = ["Customer Need", "Service Model", "Technology", "Operations", "Operating Business"];

export default function Businesses() {
  const reduce = useReducedMotion();
  return (
    <section
      id="businesses"
      data-testid="businesses-section"
      className="scroll-mt-20 bg-[#0E0D09] py-20 sm:py-24"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <SectionTag index="10">Our Businesses</SectionTag>
        </Reveal>
        <div className="mt-6 grid gap-10 lg:grid-cols-2">
          <h2
            data-testid="businesses-headline"
            className="font-serif text-3xl font-normal leading-[1.12] tracking-tight text-slate-100 sm:text-4xl lg:text-[44px]/[1.14]"
          >
            <MaskedLines delay={0.1}>
              Businesses built around
              <br />
              <span className="italic text-transparent bg-gradient-to-r from-[#F0DDA6] via-[#E7CE8B] to-[#C9A227] bg-clip-text">
                real-world customer needs.
              </span>
            </MaskedLines>
          </h2>
          <Reveal delay={0.2}>
            <p className="max-w-xl text-base font-normal leading-relaxed text-slate-300 sm:text-lg lg:ml-auto">
              Logibyte develops and operates selected businesses in service
              categories where better technology, structured operations and
              stronger customer journeys can create meaningful value.
            </p>
          </Reveal>
        </div>

        {/* conceptual portfolio framework */}
        <Reveal delay={0.2}>
          <div
            data-testid="businesses-framework"
            className="relative mt-14 overflow-hidden rounded-2xl border border-white/10 bg-[#0A0906] px-6 py-10 sm:px-10"
          >
            <div
              className="pointer-events-none absolute left-1/2 top-1/2 h-[80%] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#D4AF37]/[0.05] blur-[90px]"
              aria-hidden="true"
            />
            <p className="relative mb-8 text-[10px] font-medium uppercase tracking-[0.3em] text-stone-500">
              How a Logibyte Business Takes Shape
            </p>
            <div className="relative hidden lg:block">
              <FlowH steps={FRAMEWORK} reduce={reduce} />
            </div>
            <div className="relative mx-auto max-w-md lg:hidden">
              <FlowV steps={FRAMEWORK} reduce={reduce} />
            </div>
          </div>
        </Reveal>

        {/* selected businesses — honest note, no placeholders */}
        <Reveal delay={0.25}>
          <div data-testid="businesses-selected" className="mt-12 max-w-3xl border-l-2 border-[#D4AF37]/50 pl-8">
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#E7CE8B]">
              Selected Businesses
            </p>
            <p className="mt-4 text-[15px] font-normal leading-relaxed text-stone-400 sm:text-base">
              As portfolio businesses are prepared for public presentation,
              they may be introduced here with their customer proposition,
              operating model and digital platform.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <ArrowLink to="/businesses" testid="businesses-explore-link">
            Explore Our Businesses
          </ArrowLink>
        </Reveal>
      </div>
    </section>
  );
}
